import React from "react";
import Stack from "../../stack/Stack";
import Typography from "../../typography/Typography";
import styled from "@emotion/styled";
import { css } from "@emotion/react";

export interface FormFieldProps {
  label: string;
  htmlFor: string;
  children: React.ReactNode;
  hideLabel?: boolean;
  invalid?: boolean;
  errorMesage?: string;
}

const StyledFormField = styled(Stack)`
  ${({ theme: { space } }) => css`
    display: flex;
    flex-direction: column;

    label {
      flex-grow: 1;
    }
  `}
`;

export const FormField: React.FC<FormFieldProps> = ({
  label,
  htmlFor,
  hideLabel,
  children,
  invalid,
  errorMesage,
}) => {
  return (
    <StyledFormField gap={hideLabel ? 'none' : 'xSmall'}>
      <Typography
        component="label"
        variant="bodyBold"
        htmlFor={htmlFor}
        visuallyHidden={hideLabel}
      >
        {label}
      </Typography>
      <div>{children}</div>
      {invalid && (
        <Typography variant="body" color="red" id={`${htmlFor}-error`}>
          {errorMesage}
        </Typography>
      )}
    </StyledFormField>
  );
};

export default FormField;
